import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import IndexClient from '@/views/IndexClient'
import Test from '@/views/Test'
import Login from '@/views/Login'
import CustomerHistory from '@/views/CustomerHistory/Index'
import CustomerHistoryDetail from '@/views/CustomerHistory/Detail'
import CustomerNew from '@/views/Customer/New'
import CustomerDetail from '@/views/Customer/Detail'
import EffectHistory from '@/views/Effect/History'
import EffectCollect from '@/views/Effect/Collect'
import EffectDetail from '@/views/Effect/Detail'
import EffectSave from '@/views/Effect/Save'
import EffectAiEdit from '@/views/Effect/AiEdit'
import EffectVideo from '@/views/Effect/Video'
import Material from '@/views/Material/Index'
import MaterialPerson from '@/views/Material/Person'
import Workblank from '@/views/Workblank'
import TextToImage from '@/views/TextToImage/Index'
import TextToVideo from '@/views/TextToVideo/Index'
import FloorplanToColor from '@/views/FloorplanToColor/Index'
import ColorTo3D from '@/views/ColorTo3D/Index'
import VideoStitching from '@/views/VideoStitching/Index'
import Kaka from '@/views/Kaka/Index'

Vue.use(Router)

export default new Router({
  mode: 'history', // 启用 HTML5 History 模式
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/client',
      name: 'IndexClient',
      component: IndexClient
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/customerhistory',
      name: 'CustomerHistory',
      component: CustomerHistory
    },
    {
      path: '/customerhistorydetail/:id',
      name: 'CustomerHistoryDetail',
      component: CustomerHistoryDetail
    },
    {
      path: '/customernew',
      name: 'CustomerNew',
      component: CustomerNew
    },
    {
      path: '/customerdetail/:id',
      name: 'CustomerDetail',
      component: CustomerDetail
    },
    {
      path: '/effecthistory',
      name: 'EffectHistory',
      component: EffectHistory
    },
    {
      path: '/effectdetail/:id',
      name: 'EffectDetail',
      component: EffectDetail
    },
    {
      path: '/effectsave',
      name: 'EffectSave',
      component: EffectSave
    },
    {
      path: '/effectvideo',
      name: 'EffectVideo',
      component: EffectVideo
    },
    {
      path: '/effectaiedit',
      name: 'EffectAiEdit',
      component: EffectAiEdit
    },
    {
      path: '/effectcollect',
      name: 'EffectCollect',
      component: EffectCollect
    },
    {
      path: '/material',
      name: 'Material',
      component: Material
    },
    {
      path: '/materialperson',
      name: 'MaterialPerson',
      component: MaterialPerson
    },
    {
      path: '/workblank',
      name: 'Workblank',
      component: Workblank
    },
    {
      path: '/texttoimage',
      name: 'TextToImage',
      component: TextToImage
    },
    {
      path: '/texttovideo',
      name: 'TextToVideo',
      component: TextToVideo
    },
    {
      path: '/floorplantocolor',
      name: 'FloorplanToColor',
      component: FloorplanToColor
    },
    {
      path: '/colorto3d',
      name: 'ColorTo3D',
      component: ColorTo3D
    },
    {
      path: '/videostitching',
      name: 'VideoStitching',
      component: VideoStitching
    },
    {
      path: '/kaka',
      name: 'Kaka',
      component: Kaka
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js